import { a as u, f as y, e as i, b as d, d as m, m as s, n as g, j as C, i as l, h as b, g as h, c as S, l as T, k as N } from "./domains-162ab8d8.js";
const o = {
  asurion: { code: "SG", country: "Singapore", countryCodeNumber: "65" },
  starhub: { code: "SG", country: "Singapore", countryCodeNumber: "65" },
  true: { code: "SG", country: "Singapore", countryCodeNumber: "65" },
  techcare: { code: "TH", country: "Thailand", countryCodeNumber: "65" },
  asurion_techcare: { code: "TH", country: "Thailand", countryCodeNumber: "65" },
  celcom: { code: "MY", country: "Malaysia", countryCodeNumber: "60" },
  umobile: { code: "MY", country: "Malaysia", countryCodeNumber: "60" },
  lazada: { code: "TH", country: "Thailand", countryCodeNumber: "65" },
  maxis: { code: "MY", country: "Malaysia", countryCodeNumber: "60" },
  demo1: { code: "SG", country: "Singapore", countryCodeNumber: "65" },
  smart: { code: "PH", country: "Philippines", countryCodeNumber: "63" },
  twopenmarket_synnex: { code: "TW", country: "Taiwan", countryCodeNumber: "886" },
  cht_home: { code: "TW", country: "Taiwan", countryCodeNumber: "886" },
  jbhifi: { code: "AUS", country: "Australia", countryCodeNumber: "61" },
  twopenmarket_slw: { code: "TW", country: "Taiwan", countryCodeNumber: "886" },
  twopenmarket_ews: { code: "TW", country: "Taiwan", countryCodeNumber: "886" },
  sh_device_Care: { code: "SG", country: "Singapore", countryCodeNumber: "65" },
  m1: { code: "SG", country: "Singapore", countryCodeNumber: "65" },
  singtel: { code: "SG", country: "Singapore", countryCodeNumber: "65" },
  fet: { code: "TW", country: "Taiwan", countryCodeNumber: "886" }
}, r = {
  asurion: "en-US",
  starhub: "en-US",
  true: "en-US",
  techcare: "th-TH",
  asurion_techcare: "th-TH",
  celcom: "ms-MY",
  umobile: "ms-MY",
  lazada: "th-TH",
  maxis: "en-US",
  demo1: "en-US",
  twopenmarket_synnex: "zh-Hant-TW",
  cht_home: "zh-Hant-TW",
  smart: "en-US",
  jbhifi: "en-US",
  twopenmarket_slw: "zh-Hant-TW",
  sh_device_care: "en-US",
  m1: "en-US"
}, n = (e) => o[e] || { code: "", country: "", countryCodeNumber: "" }, a = (e) => r[e] || "en-US";
export {
  u as getCarrierByDomain,
  y as getClientConfigByDomain,
  i as getConfigNameByDomain,
  n as getCountryByCarrier,
  a as getDefaultLanguageByCarrier,
  d as getEnvByDomain,
  m as getHasRetailerByDomain,
  s as getPartnerIdByDomain,
  g as getRedirectToPortal,
  C as getRetailerFileFolderNameByDomain,
  l as getRetailerNameByDomain,
  b as getSharedTypesByDomain,
  h as getTypeByDomain,
  S as getUrlByTypeAndEnv,
  T as hasPartnerIdByDomain,
  N as isAuthPortalMerged
};
